import {combineReducers} from 'redux';
import projects from "./projects";
import login from "./login";
import products from "./products";
import error from "./error";
import {ProductDataItem} from "../types/StudioAPITypes";
import loading from "./loading";
import {Dictionary, LogLevel} from "../types/Types";
import {ErrorResponse, ProjectDataItem} from "../types/StudioAPITypes";

export default combineReducers({
  projects: projects,
  login: login,
  products: products,
  loading: loading,
  error: error
});

export interface State {
  login: LoginState;
  projects: ProjectsState;
  products: ProductState;
  loading: LoadingState;
  error: ErrorState;
}

export interface LoginMessage {
  text: string,
  level: LogLevel
}

export interface LoginState {
  showRecaptcha: boolean;
  recaptcha: number;
  failedAttempts: number;
  email: string;
  firstName: string;
  lastName: string;
  id: number;
  superAdmin: boolean;
  message: LoginMessage | null;
  isSubmitted: boolean;
  targetUrl: string | null;
  twoFaSetupUrl: string | null;
  otpToken: string | null;
}

export interface ProjectsState {
  items: ProjectDataItem[];
  filter: string;
}

export interface ProgressObject {
  progress: number;
  status: string
}

export interface ProductState {
  projectId: string;
  projectName: string;
  items: ProductDataItem[];
  filter: string;
  itemInEditMode: string;
  fileImport: ProgressObject;
}

export interface LoadingItem {
  showLoader: boolean
}

export type LoadingState = Dictionary<LoadingItem>;

export type ErrorState = Dictionary<ErrorResponse>;
